import { render, staticRenderFns } from "./apiVisitorDelete.vue?vue&type=template&id=2bc6930e&scoped=true&"
import script from "./apiVisitorDelete.vue?vue&type=script&lang=js&"
export * from "./apiVisitorDelete.vue?vue&type=script&lang=js&"
import style0 from "./apiVisitorDelete.vue?vue&type=style&index=0&id=2bc6930e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6930e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
